/*
 * QUEST SOFTWARE PROPRIETARY INFORMATION
 *
 * This software is confidential.  Quest Software Inc., or one of its
 * subsidiaries, has supplied this software to you under terms of a
 * license agreement, nondisclosure agreement or both.
 *
 * You may not copy, disclose, or use this software except in accordance with
 * those terms.
 *
 *
 * Copyright 2026 Quest Software Inc.
 * ALL RIGHTS RESERVED.
 *
 * QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
 * WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
 * EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
 * TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE, OR
 * NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
 * AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
 * THIS SOFTWARE OR ITS DERIVATIVES.
 */

export const ALARM_ENDPOINTS = {
    GET_ALARM_TEMPLATES: '/api/v1/alarm-templates',
    ADD_NEW_ALARM_TEMPLATE: '/api/v1/alarm-templates',
    DELETE_ALARM_TEMPLATE: (id: string) => `/api/v1/alarm-templates/${id}`,
    CLONE_ALARM_TEMPLATE: (id: string) => `/api/v1/alarm-templates/${id}/clone`,
    UPDATE_ALARM_TEMPLATE: (id: string) => `/api/v1/alarm-templates/${id}`,
    SET_DEFAULTS: '/api/v1/alarm-templates/set-defaults',
    GET_ALARM_TEMPLATE_DETAIL: (templateId: string) => `/api/v1/alarm-templates/${templateId}`,
    GET_DOMAIN_RULE_COUNTS: '/api/v1/alarm-templates/domains/rule-count',
    GET_DOMAIN_ROOT_TYPES: (domain: string) => `/api/v1/alarm-templates/domains/${domain}/root-types`,
    GET_FULL_ASSIGNED_TARGETS: (alarmTemplateId: string, domainName: string) => `/api/v1/alarm-templates/${alarmTemplateId}/${domainName}/assigned-targets`,
    GET_DOMAIN_OBJECT_COUNTS: '/api/v1/alarm-templates/domains/object-count',
    GET_RULE_CONFIGS: (alarmTemplateId: string, domainName: string) => `/api/v1/alarm-templates/${alarmTemplateId}/${domainName}/rule-configs`,
    GET_TARGETS_CURRENT_ALARM_TEMPLATES: '/api/v1/alarm-templates/targets/current-template',
    ASSIGN_TARGETS_TO_TEMPLATE: (alarmTemplateId: string) => `/api/v1/alarm-templates/${alarmTemplateId}/assign-targets`,
    UNASSIGN_TARGETS: (alarmTemplateId: string) => `/api/v1/alarm-templates/${alarmTemplateId}/unassign-targets`
  };


  export const THEME_KEY = 'theme';
  export const DARK_THEME = 'dark-theme';
  export const LIGHT_THEME_BACKGROUND = 'light-theme-background';
  export const DARK_THEME_BACKGROUND = 'dark-theme-background';
  export const DEFAULT_TEMPLATE_ID = 'default'
  